import React from 'react';

const PageNotFound = () => {
  return (
    <div>
      {/* <h1>404 Page</h1> */}
    </div>
  );
};

export default PageNotFound;